const stdCategories = {
  en: {
    'Stadium Concert': 'stadium_concert',
    'Ballet performance': 'ballet_performance',
    'Choral concert': 'choral_concert',
    'Club gig': 'club_gig',
    'Electronic music festival': 'electronic_music_festival',
    'Film-in-concert': 'film_in_concert',
    'Hip-hop show': 'hip_hop_show',
    'Music theater': 'music_theater',
    Recital: 'recital',
    'Singer-songwriter': 'singer_songwriter',
    'Orchestra concert': 'orchestra_concert',
    'World/traditional music concert': 'world_traditional_music_concert',
    'Theater play': 'theater_play',
    Comedy: 'comedy',
    'Contemporary dance': 'contemporary_dance',
    'Nightlife event': 'nightlife_event',
    Other: 'other',
    'Conference and fairs': 'conference_and_fairs',
    'Corporate events': 'corporate_events',
    'Sports — Individual & Combat': 'sports_individual_combat',
    'Sports — Motorsports': 'sports_motorsports',
    'Sports — Team Match': 'sports_team_match',
    Esports: 'esports',
    'Product/Service': 'product',
  },
  de: {
    Stadionkonzert: 'stadium_concert',
    Ballettaufführung: 'ballet_performance',
    Chorkonzert: 'choral_concert',
    Clubauftritt: 'club_gig',
    'Elektronisches Musikfestival': 'electronic_music_festival',
    Filmkonzert: 'film_in_concert',
    'Hip-Hop-Show': 'hip_hop_show',
    Musiktheater: 'music_theater',
    Rezital: 'recital',
    'Singer-Songwriter': 'singer_songwriter',
    Orchesterkonzert: 'orchestra_concert',
    'Weltmusik-/Traditionelle Musik': 'world_traditional_music_concert',
    Theaterstück: 'theater_play',
    Comedy: 'comedy',
    'Zeitgenössischer Tanz': 'contemporary_dance',
    'Nightlife Event': 'nightlife_event',
    Sonstige: 'other',
    'Konferenzen und Messen': 'conference_and_fairs',
    Firmenveranstaltungen: 'corporate_events',
    'Sport – Einzel- und Kampfsportarten': 'sports_individual_combat',
    'Sport — Motorsport': 'sports_motorsports',
    'Sport – Mannschaftswettbewerb': 'sports_team_match',
    'E-Sport': 'esports',
    'Produkt/Dienstleistung': 'product',
  },
}

export const SHEET_MAPPINGS = {
  en: {
    Events: 'Events',
    Campaign: 'Events',
    'Lineup Artists': 'Lineup Artists',
    'Setlist Works': 'Setlist Works',
    settings: 'settings',
  },
  de: {
    Veranstaltung: 'Events',
    Kampagne: 'Events',
    Künstler: 'Lineup Artists',
    Programm: 'Setlist Works',
    settings: 'settings',
  },
}

// Header ranges for first row validation
export const HEADER_RANGES = {
  Events: 'A1:K1',
  'Lineup Artists': 'A1:C1',
  'Setlist Works': 'A1:C1',
  settings: 'A1:E1',
}

// Column header mappings by locale and sheet
export const HEADER_MAPPINGS = {
  en: {
    Events: {
      // FdLive format
      Event_Identifier: 'Event_Identifier',
      'Event title*': 'Event title*',
      'Event description': 'Event description',
      'Event category*': 'Event category*',
      'Date*': 'Date*',
      'Time*': 'Time*',
      Time: 'Time*',
      'Avg. price*': 'Avg. price*',
      'Avg. price': 'Avg. price*',
      'City*': 'City*',
      City: 'City*',
      'Venue*': 'Venue*',
      Venue: 'Venue*',
      'Hall*': 'Hall*',
      Hall: 'Hall*',
      'Venue Capacity*': 'Venue Capacity*',
      'Venue Capacity': 'Venue Capacity*',

      // Prisma format (Campaign)
      Campaign_Identifier: 'Event_Identifier',
      'Title*': 'Event title*',
      'Campaign description': 'Event description',
      'Campaign category*': 'Event category*',
      'End Date*': 'Date*',
    },
    'Lineup Artists': {
      'Event Identifier': 'Event Identifier',
      'Campaign Identifier': 'Event Identifier',
      'Artist name': 'Artist name',
      'Role/Type': 'Role/Type',
    },
    'Setlist Works': {
      'Event Identifier': 'Event Identifier',
      'Campaign Identifier': 'Event Identifier',
      'Author/Composer': 'Author/Composer',
      'Work Title': 'Work Title',
    },
    settings: {
      settings: 'settings',
      value: 'value',
      aux_date_format: 'aux_date_format',
    },
  },
  de: {
    Events: {
      // FdLive format
      'Veranstaltung Identifikator': 'Event_Identifier',
      'Veranstaltungstitel*': 'Event title*',
      'Beschreibung der Veranstaltung': 'Event description',
      'Veranstaltungskategorie*': 'Event category*',
      'Datum*': 'Date*',
      'Zeit*': 'Time*',
      Zeit: 'Time*',
      'Durchschnittlicher Preis*': 'Avg. price*',
      'Durchschnittlicher Preis': 'Avg. price*',
      'Stadt*': 'City*',
      Stadt: 'City*',
      'Veranstaltungsstätte*': 'Venue*',
      Stätte: 'Venue*',
      'Saal*': 'Hall*',
      Saal: 'Hall*',
      'Platzkapazität*': 'Venue Capacity*',
      Platzkapazität: 'Venue Capacity*',

      // Prisma format (Kampagne)
      'Kampagne Identifikator': 'Event_Identifier',
      'Titel*': 'Event title*',
      'Beschreibung der Kampagne': 'Event description',
      'Kategorie der Kampagne*': 'Event category*',
    },
    'Lineup Artists': {
      'Veranstaltung Identifikator': 'Event Identifier',
      'Kampagne Identifikator': 'Event Identifier',
      'Name Künstler:in': 'Artist name',
      Typ: 'Role/Type',
    },
    'Setlist Works': {
      'Veranstaltung Identifikator': 'Event Identifier',
      'Kampagne Identifikator': 'Event Identifier',
      'Author:in': 'Author/Composer',
      'Werk des/der Author:in': 'Work Title',
    },
    settings: {
      settings: 'settings',
      value: 'value',
      aux_date_format: 'aux_date_format',
    },
  },
}

// Locale detection keywords
export const LOCALE_DETECTION = {
  de: ['Veranstaltung', 'Kampagne', 'Künstler', 'Programm', 'Anweisungen'],
  en: ['Events', 'Campaign', 'Lineup Artists', 'Setlist Works', 'Instructions'],
}

/**
 * Detect the locale of a workbook based on its sheet names
 * @param {string[]} sheetNames - Array of sheet names from the workbook
 * @returns {string} - Detected locale ('en', 'de')
 */
export function detectLocale(sheetNames) {
  if (sheetNames.some((name) => LOCALE_DETECTION.de.includes(name))) {
    return 'de'
  }

  // Default to English
  return 'en'
}

/**
 * Get the standard sheet name for a localized sheet name
 * @param {string} localizedName - The localized sheet name
 * @param {string} locale - The detected locale
 * @returns {string|null} - The standard sheet name or null if not found
 */
export function getStandardSheetName(localizedName, locale) {
  return SHEET_MAPPINGS[locale]?.[localizedName] || null
}

/**
 * Get the header mappings for a specific sheet and locale
 * @param {string} standardSheetName - The standard sheet name
 * @param {string} locale - The detected locale
 * @returns {Object} - The header mappings object
 */
export function getHeaderMappings(standardSheetName, locale) {
  return HEADER_MAPPINGS[locale]?.[standardSheetName] || {}
}

export function getCategoryMapping(localizedCategory, locale) {
  if (!localizedCategory) return localizedCategory

  const categoryMap = stdCategories[locale] || {}
  const normalizedInput = String(localizedCategory).trim().toLowerCase()
  const lowerCaseMap = {}
  Object.keys(categoryMap).forEach((key) => {
    lowerCaseMap[key.toLowerCase()] = categoryMap[key]
  })

  return lowerCaseMap[normalizedInput] || localizedCategory
}
